/* tslint:disable */
/* eslint-disable */
/**
 * Brew API
 * Microservice backend for brew management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RatingEnum } from './RatingEnum';
import {
    RatingEnumFromJSON,
    RatingEnumFromJSONTyped,
    RatingEnumToJSON,
} from './RatingEnum';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * 
 * @export
 * @interface IssueOverview
 */
export interface IssueOverview {
    /**
     * 
     * @type {number}
     * @memberof IssueOverview
     */
    readonly id: number;
    /**
     * 
     * @type {Date}
     * @memberof IssueOverview
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof IssueOverview
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {any}
     * @memberof IssueOverview
     */
    aboutCompany?: any | null;
    /**
     * 
     * @type {any}
     * @memberof IssueOverview
     */
    aboutCompanyShort?: any | null;
    /**
     * 
     * @type {any}
     * @memberof IssueOverview
     */
    aboutCompanyLong?: any | null;
    /**
     * 
     * @type {any}
     * @memberof IssueOverview
     */
    aboutProject?: any | null;
    /**
     * 
     * @type {any}
     * @memberof IssueOverview
     */
    aboutProjectShort?: any | null;
    /**
     * 
     * @type {any}
     * @memberof IssueOverview
     */
    aboutProjectLong?: any | null;
    /**
     * 
     * @type {any}
     * @memberof IssueOverview
     */
    keyStrengths?: any | null;
    /**
     * 
     * @type {any}
     * @memberof IssueOverview
     */
    moneyUsagePlan?: any | null;
    /**
     * 
     * @type {any}
     * @memberof IssueOverview
     */
    moneyUsageDetails?: any | null;
    /**
     * 
     * @type {string}
     * @memberof IssueOverview
     */
    projectName: string;
    /**
     * 
     * @type {any}
     * @memberof IssueOverview
     */
    reasonsToInvest?: any | null;
    /**
     * 
     * @type {RatingEnum}
     * @memberof IssueOverview
     */
    rating: RatingEnum;
    /**
     * 
     * @type {any}
     * @memberof IssueOverview
     */
    tagline?: any | null;
    /**
     * 
     * @type {any}
     * @memberof IssueOverview
     */
    tags?: any | null;
    /**
     * 
     * @type {any}
     * @memberof IssueOverview
     */
    ownerData?: any | null;
    /**
     * 
     * @type {any}
     * @memberof IssueOverview
     */
    ownerDescriptionShort?: any | null;
    /**
     * 
     * @type {any}
     * @memberof IssueOverview
     */
    ownerDescriptionLong?: any | null;
    /**
     * 
     * @type {number}
     * @memberof IssueOverview
     */
    issue: number;
}



/**
 * Check if a given object implements the IssueOverview interface.
 */
export function instanceOfIssueOverview(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('createdAt' in value)) return false;
    if (!('updatedAt' in value)) return false;
    if (!('projectName' in value)) return false;
    if (!('rating' in value)) return false;
    if (!('issue' in value)) return false;
    return true;
}

export function IssueOverviewFromJSON(json: any): IssueOverview {
    return IssueOverviewFromJSONTyped(json, false);
}

export function IssueOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): IssueOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (dayjs(json['created_at']).toDate()),
        'updatedAt': (dayjs(json['updated_at']).toDate()),
        'aboutCompany': json['about_company'] == null ? undefined : json['about_company'],
        'aboutCompanyShort': json['about_company_short'] == null ? undefined : json['about_company_short'],
        'aboutCompanyLong': json['about_company_long'] == null ? undefined : json['about_company_long'],
        'aboutProject': json['about_project'] == null ? undefined : json['about_project'],
        'aboutProjectShort': json['about_project_short'] == null ? undefined : json['about_project_short'],
        'aboutProjectLong': json['about_project_long'] == null ? undefined : json['about_project_long'],
        'keyStrengths': json['key_strengths'] == null ? undefined : json['key_strengths'],
        'moneyUsagePlan': json['money_usage_plan'] == null ? undefined : json['money_usage_plan'],
        'moneyUsageDetails': json['money_usage_details'] == null ? undefined : json['money_usage_details'],
        'projectName': json['project_name'],
        'reasonsToInvest': json['reasons_to_invest'] == null ? undefined : json['reasons_to_invest'],
        'rating': RatingEnumFromJSON(json['rating']),
        'tagline': json['tagline'] == null ? undefined : json['tagline'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'ownerData': json['owner_data'] == null ? undefined : json['owner_data'],
        'ownerDescriptionShort': json['owner_description_short'] == null ? undefined : json['owner_description_short'],
        'ownerDescriptionLong': json['owner_description_long'] == null ? undefined : json['owner_description_long'],
        'issue': json['issue'],
    };
}

export function IssueOverviewToJSON(value?: IssueOverview | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'about_company': value['aboutCompany'],
        'about_company_short': value['aboutCompanyShort'],
        'about_company_long': value['aboutCompanyLong'],
        'about_project': value['aboutProject'],
        'about_project_short': value['aboutProjectShort'],
        'about_project_long': value['aboutProjectLong'],
        'key_strengths': value['keyStrengths'],
        'money_usage_plan': value['moneyUsagePlan'],
        'money_usage_details': value['moneyUsageDetails'],
        'project_name': value['projectName'],
        'reasons_to_invest': value['reasonsToInvest'],
        'rating': RatingEnumToJSON(value['rating']),
        'tagline': value['tagline'],
        'tags': value['tags'],
        'owner_data': value['ownerData'],
        'owner_description_short': value['ownerDescriptionShort'],
        'owner_description_long': value['ownerDescriptionLong'],
        'issue': value['issue'],
    };
}

